import React from 'react'

import { Field } from 'formik'

import { Table, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaRequerimientoCell = ({ row, dispatch, iError, iTouched, handleChange }) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)

      dispatch({
        type: 'actualizar',
        payload: {
          ...row,
          fechaRequerimiento: e.target.value
        }
      })
    },
    [handleChange, dispatch, row]
  )

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('productoSelect', e)
  }, [])

  return (
    <Table.Cell>
      <Field name='fechaRequerimiento'>
        {({ field }) => (
          <Form.InputDate
            {...field}
            id={`${row._idFila}-fechaRequerimiento`}
            isInvalid={iTouched && iError}
            onChange={onChange}
            onKeyDown={onKeyDown}
          />
        )}
      </Field>
    </Table.Cell>
  )
}

export default React.memo(FechaRequerimientoCell)
